import React from 'react';
import Grid from '@material-ui/core/Grid';
import MDXParser from '../mdxParser';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Img from '../wrappedImage';
import { useStaticQuery, graphql } from 'gatsby';
import { useInView } from 'react-intersection-observer';
import clsx from 'clsx';

// Content
import JoycePartOne from '../../sections/Stories/JoyceOne';
import JoycePartTwo from '../../sections/Stories/JoyceTwo';

import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      backgroundColor: '#a01d43',
    },
    rootDetail: {},
    text: {
      color: 'white',
      padding: '20px 0px 60px 50px!important'
    },
    image: {
      width: '100%',
      height: 'auto',
    },
    imageContainer: {
      display: 'flex',
      position: 'relative',
    },
    title: {
      fontStyle: 'italic',
      color: 'white!important',
      marginLeft: '10px',
    },
    animation: {
      animationName: '$title',
      animationDuration: '1s',
    },
    '@keyframes title': {
      ...animationFunc(),
    },
  }),
);

function animationFunc() {
  return {
    '0%': { opacity: 0 },
    '20%': { opacity: 0 },
    '40%': { opacity: 0.3 },
    '60%': { opacity: 0.5 },
    '80%': { opacity: 0.9 },
    '100%': { opacity: 1 },
  };
}

type Props = { children: React.ReactNode; image: string };

const StoryTwoSection = () => {
  const classes = useStyles();

  const [ref, inView] = useInView({
    threshold: 0,
  });

  const data = useStaticQuery(graphql`
    query {
      joyce: file(relativePath: { eq: "joycetamari.jpg" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  return (
    <Container maxWidth={false} disableGutters={true} className={classes.container} ref={ref}>
      <Container className={classes.imageContainer}>
        <Grid container spacing={3} className={classes.imageContainer}>
          <Grid item xs={12} md={6} className={classes.imageContainer}>
            <Img fluid={data.joyce.childImageSharp.fluid} className={classes.image} alt="Image" copyText='WFP/Alice Maro' />
          </Grid>
          <Grid item xs={12} md={6}  className={classes.text}>
            <div className={classes.title}>
              <Typography
                variant="h3"
                gutterBottom={false}
                className={clsx(inView && classes.animation)}
              >
                <JoycePartOne />
              </Typography>
            </div>
            <div>
              <MDXParser linkColor="white">
                <JoycePartTwo />
              </MDXParser>
            </div>
          </Grid>
        </Grid>
      </Container>
    </Container>
  );
};

export default StoryTwoSection;
